import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {TablerIconsModule} from "angular-tabler-icons";
import {LoadingModule} from "../../../../../../../components/common/loading/loading.module";

@Component({
  selector: 'app-luna-button',
  standalone: true,
    imports: [CommonModule, TablerIconsModule, LoadingModule],
  templateUrl: './button.component.html',
  styleUrls: [
      './button.component.scss'
  ]
})
export class ButtonComponent implements OnChanges {
    @Input() iconName: string;
    @Input() label: string;
    @Input() color: 'primary' | 'accent' | 'white' = 'accent';
    @Input() active = false;
    @Input() loading = false;

    @Output() clickedEvent: EventEmitter<void> = new EventEmitter();

    _type: 'iconOnly' | 'labelOnly' | 'iconAndLabel' = 'labelOnly';

  ngOnChanges(changes: SimpleChanges): void {
    if (this.iconName && this.label) {
      this._type = 'iconAndLabel';
    } else if (this.iconName) {
      this._type = 'iconOnly';
    } else {
      this._type = 'labelOnly';
    }
  }

  click() {
    this.clickedEvent.emit();
  }

}
